import { SatisfactionSurveyTemplate } from "../../Templates/SatisfactionSurveyTemplate";

export const SatisfactionSurvey = () => {
  return <SatisfactionSurveyTemplate />;
};
